import { GetterTree } from 'vuex'
import { MapaPeligroState } from '@/store/modules/mapa-peligro/types'
import { RootState } from '@/store/types'

export const getters: GetterTree<MapaPeligroState, RootState> = {
  mapaPeligros (state: MapaPeligroState) {
    return state.mapasPeligro
  },
  menuPeligro (state: MapaPeligroState) {
    return state.mapasPeligro.map((peligro, index) => ({ mapa: index, description: peligro.tipo, icono: peligro.icono, toggle: peligro.toggle }))
  }
}
